import React from 'react';
import cn from 'classnames';
import { Checkbox } from "../../Checkbox";
import { Typography } from "../../Typography";
import styles from "./CheckboxWithLabel.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CheckboxWithLabel = _ref => {
  let {
    id,
    label,
    sublabel,
    checked,
    testId,
    className,
    onChange
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: cn(styles.root, className),
    "data-testid": testId,
    children: /*#__PURE__*/_jsx(Checkbox, {
      id: id,
      "data-testid": "".concat(testId, "-checkbox"),
      onChange: onChange,
      checked: checked,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.label,
        children: [/*#__PURE__*/_jsx(Typography, {
          children: label
        }), sublabel && /*#__PURE__*/_jsx(Typography, {
          skin: "secondary",
          children: sublabel
        })]
      })
    })
  });
};